import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { AuthService } from '@app/service/auth.service';
import { leadUtilityFunctions } from '@data/services/lead/lead-utility-functions';
import { LeadService } from '@data/services/lead/lead.service';
import { ToastMsgService } from '@shared/services/toastr/toast-msg.service';
import { first, Subscription } from 'rxjs';

@Component({
  standalone: false,
  selector: 'app-external-soa',
  templateUrl: './external-soa.component.html',
  styleUrls: ['./external-soa.component.scss']
})
export class ExternalSoaComponent implements OnInit {
  private getSoaSourcesSubs : Subscription;
  private addExternalSOASubs : Subscription;
  public externalForm : FormGroup;
  public isButtonClick : boolean = false;
  public soaSources : {soa_source_id: string, soa_source_name: string}[] = [];

  constructor(
    private fb : FormBuilder,
    private auth: AuthService,
    private leadService: LeadService,
    private dialog: MatDialog,
    private toastMsgService: ToastMsgService,
    public luf : leadUtilityFunctions,
    @Inject(MAT_DIALOG_DATA) public data: any) {

    this.externalForm = this.fb.group({
      'appointmentDate' : ['', Validators.required],
      'clientSignedDate' : ['', Validators.required],
      'externalSource' : ['', Validators.required],
    });

  }

  ngOnInit(): void {
    this.getSoaSourcesSubs = this.leadService.getSOASources().pipe(first()).subscribe({
      next: (res: any) => {
        this.soaSources = res.filter((source: {soa_source_id: string, soa_source_name: string}) => source.soa_source_id !== '1');
      },
      error: (err) => {
        this.toastMsgService.showError(err.error.message);
      }
    });
  }

  public saveExternalSOA() {
    if(this.externalForm.invalid){
      return;
    } else {
      this.isButtonClick = true;
      let payload = {
        lead_id: this.leadService.lead_details.lead_id,
        soa_source_id: this.externalForm.value.externalSource,
        appointment_date: this.externalForm.value.appointmentDate,
        client_esign_date: this.externalForm.value.clientSignedDate
      };

      this.addExternalSOASubs = this.leadService.addExternalSOA(payload).pipe(first()).subscribe({
        next: (res: any) => {
          if (res) {
            this.isButtonClick = false;
            this.dialog.closeAll();
            this.toastMsgService.showSuccess('The External Scope Of Appointment was submitted.');
          }
        }, error: err => {
          this.isButtonClick = false;
          this.toastMsgService.showError('The External Scope Of Appointment was not submitted. ' + err.error.message);
        }
      });
    }
  }

  public ngOnDestroy(){
    if (this.getSoaSourcesSubs) this.getSoaSourcesSubs.unsubscribe();
    if (this.addExternalSOASubs) this.addExternalSOASubs.unsubscribe();
  }

}
